var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 355,
    viewBox: "0 0 457 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online-Services"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.817 353.904L0.227295 217.305L0.26169 198.212L28.1284 188.672L245.822 315.959L249.834 345.731L236.817 353.904Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.815 354.341L0.227051 217.745V215.206L236.815 351.948V354.341Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.773 227.595L236.815 354.342L236.815 314.489L420.669 196.189L456.757 208.004L456.773 227.595Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.227051 198.262L236.809 335.551L456.757 208.004L220.03 83.1703L0.227051 198.262Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M113.273 191.08C121.391 195.636 121.391 203.154 113.273 207.907C104.13 212.561 93.3124 212.561 84.1706 207.907C76.0549 203.352 76.0549 195.832 84.1706 191.08C93.3124 186.426 104.13 186.426 113.273 191.08Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M93.0784 148.312C108.168 148.312 120.4 161.076 120.4 176.822C120.4 192.568 108.168 205.332 93.0784 205.332C77.9871 205.332 65.7567 192.568 65.7567 176.822C65.7567 161.076 77.9871 148.312 93.0784 148.312Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M112.674 188.897C100.467 195.032 86.0738 195.032 73.8685 188.897C68.3175 185.728 65.7545 181.571 65.7545 177.413C65.3243 183.214 68.4547 188.696 73.671 191.271C85.8763 197.408 100.268 197.408 112.475 191.271C116.99 188.718 120.01 184.153 120.592 178.997C119.566 183.314 116.66 186.947 112.674 188.897Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M109.897 171.276C99.3158 176.623 86.8225 176.623 76.241 171.276C72.6955 169.616 70.1308 166.391 69.3106 162.565C68.7146 166.326 71.0934 170.273 76.241 173.257C86.8225 178.603 99.3158 178.603 109.897 173.257C115.043 170.285 117.221 166.326 116.826 162.565C116.061 166.418 113.48 169.662 109.897 171.276Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M75.4673 209.239C80.5257 212.078 80.5257 216.763 75.4673 219.725C69.7693 222.625 63.0282 222.625 57.3312 219.725C52.2738 216.886 52.2738 212.2 57.3312 209.239C63.0282 206.339 69.7693 206.339 75.4673 209.239Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M62.8787 182.588C72.2821 182.588 79.9048 190.542 79.9048 200.354C79.9048 210.167 72.2821 218.121 62.8787 218.121C53.4743 218.121 45.8527 210.167 45.8527 200.354C45.8527 190.542 53.4743 182.588 62.8787 182.588Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M75.0943 207.881C67.4873 211.704 58.5179 211.704 50.9119 207.881C47.4527 205.906 45.8556 203.316 45.8556 200.724C45.5875 204.339 47.5382 207.756 50.7888 209.36C58.3948 213.184 67.3632 213.184 74.9702 209.36C77.7837 207.769 79.6656 204.924 80.0286 201.711C79.3892 204.402 77.5782 206.666 75.0943 207.881Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M73.3635 196.9C66.7694 200.232 58.984 200.232 52.39 196.9C50.1805 195.865 48.5823 193.856 48.0711 191.471C47.6997 193.815 49.1821 196.275 52.39 198.134C58.984 201.466 66.7694 201.466 73.3635 198.134C76.5703 196.282 77.9275 193.815 77.6813 191.471C77.2045 193.873 75.5959 195.894 73.3635 196.9Z",
    fill: "#D9D9D0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stecker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M425.359 226.248L445.41 244.533L428.859 253.581L427.273 259.823L402.505 255.955L401.497 240.01L425.359 226.248Z",
    fill: "#D8D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M401.497 259.144L429.078 263.731L428.858 253.581L401.497 240.01V259.144Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M445.408 254.326V244.533L428.857 253.581L429.078 263.732L445.408 254.326Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M439.984 248.375C435.102 247.548 429.144 257.849 434.191 260.456L442.177 264.013L448.052 253.575L439.984 248.375Z",
    fill: "#D8D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M442.067 256.606C440.124 259.319 439.918 262.498 441.606 263.707C443.294 264.915 446.237 263.697 448.179 260.984C450.122 258.272 450.328 255.093 448.64 253.883C446.952 252.676 444.009 253.895 442.067 256.606Z",
    fill: "#8D8A83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Zahnrad und Monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M186.835 252.08L293.138 188.256L337.025 210.262L327.512 214.96L224.105 272.345L186.835 252.08Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tastatur unfertig"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 445",
    d: "M187.537 247.065L289.616 188.014L322.795 207.021L220.716 266.073L187.537 247.065Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 446",
    d: "M220.56 265.996L322.653 206.917L322.652 211.751L220.56 270.789L220.56 265.996Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 447",
    d: "M187.538 247.059L220.611 265.969L220.611 270.835L187.538 251.925L187.538 247.059Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 448",
    d: "M191.597 245.699L288.37 189.679L317.406 206.305L220.634 262.324L191.597 245.699Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 449",
    d: "M220.636 262.302L317.405 206.273L317.403 207.47L220.634 263.457L220.636 262.302Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 450",
    d: "M191.604 245.701L220.631 262.311L220.632 263.471L191.604 246.861L191.604 245.701Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 451",
    d: "M214.356 258.746L311.125 202.718L311.123 203.915L214.354 259.901L214.356 258.746Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 452",
    d: "M214.327 259.909L215.384 259.298L215.384 260.568H214.409L214.327 259.909Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 453",
    d: "M311.116 202.717L312.169 202.109V203.3L311.116 203.907V202.717Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 454",
    d: "M208.186 255.262L304.955 199.234L304.953 200.431L208.185 256.418L208.186 255.262Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 455",
    d: "M208.158 256.427L209.215 255.816L209.216 257.085H208.24L208.158 256.427Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 456",
    d: "M304.948 199.231L306.001 198.623V199.814L304.948 200.421V199.231Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 457",
    d: "M202.528 251.879L299.298 195.851L299.295 197.047L202.527 253.034L202.528 251.879Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 458",
    d: "M202.497 253.046L203.554 252.435L203.554 253.704H202.578L202.497 253.046Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 459",
    d: "M299.283 195.848L300.336 195.239V196.43L299.283 197.037V195.848Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 460",
    d: "M196.289 248.346L293.058 192.318L293.056 193.515L196.287 249.502L196.289 248.346Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 461",
    d: "M196.266 249.51L197.323 248.899L197.323 250.168H196.347L196.266 249.51Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 462",
    d: "M293.052 192.312L294.105 191.704V192.895L293.052 193.502V192.312Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 463",
    d: "M222.724 255.067L227.905 258.054L227.905 259.215L222.724 256.227L222.724 255.067Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 480",
    d: "M212.32 247.388L217.108 250.126L217.108 251.286L212.32 248.548L212.32 247.388Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 481",
    d: "M204.531 244.668L209.712 247.656L209.712 248.816L204.531 245.829L204.531 244.668Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 482",
    d: "M198.848 241.43L204.029 244.417L204.029 245.578L198.848 242.59L198.848 241.43Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 464",
    d: "M226.93 258.664L227.902 259.21V260.463H226.93V258.664Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 468",
    d: "M216.087 250.691L217.104 251.28L216.087 251.867V250.691Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 467",
    d: "M222.721 255.068L221.678 255.645L222.721 256.279V255.068Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 483",
    d: "M228.861 251.496L234.101 254.518L234.101 255.678L228.862 252.656L228.861 251.496Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 484",
    d: "M233.13 255.121L234.102 255.666V256.919H233.13V255.121Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 485",
    d: "M228.881 251.497L227.876 252.071L228.881 252.672L228.881 251.497Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 495",
    d: "M228.881 251.851L228.222 252.266L228.881 252.669L228.881 251.851Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 486",
    d: "M234.601 248.168L239.84 251.19L239.84 252.35L234.601 249.328L234.601 248.168Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 487",
    d: "M238.865 251.789L239.837 252.335V253.588H238.865V251.789Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 488",
    d: "M234.617 248.166L233.612 248.74L234.617 249.341L234.617 248.166Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 489",
    d: "M260.068 233.441L265.307 236.463L265.308 237.623L260.068 234.602L260.068 233.441Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 490",
    d: "M264.336 237.065L265.308 237.611V238.864H264.336V237.065Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 491",
    d: "M260.083 233.439L259.078 234.013L260.083 234.614L260.083 233.439Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 492",
    d: "M267.168 229.342L272.407 232.364L272.407 233.524L267.168 230.502L267.168 229.342Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 493",
    d: "M271.43 232.964L272.402 233.509V234.762H271.43V232.964Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 494",
    d: "M267.182 229.341L266.177 229.915L267.182 230.516L267.182 229.341Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TastenRand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 479",
    d: "M218.105 250.686L223.246 253.609L223.246 254.802L218.105 251.846L218.105 250.686Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 465",
    d: "M222.2 254.197L223.247 254.794L222.2 255.372V254.197Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 466",
    d: "M223.246 253.613L224.264 254.165L223.246 254.789V253.613Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 469",
    d: "M218.105 250.655L217.058 251.288L218.105 251.866V250.655Z",
    fill: "#6D6C6C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 470",
    d: "M217.092 250.108L218.111 250.661L217.092 251.284V250.108Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 471",
    d: "M208.771 248.265L209.818 248.862L208.771 249.441V248.265Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 472",
    d: "M212.319 247.355L211.272 247.987L212.319 248.566V247.355Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 473",
    d: "M209.776 247.681L210.794 248.234L209.776 248.857V247.681Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 474",
    d: "M202.557 244.703L203.604 245.301L202.557 245.879V244.703Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 475",
    d: "M204.58 244.671L203.533 245.304L204.58 245.882V244.671Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 476",
    d: "M203.565 244.119L204.583 244.672L203.565 245.295V244.119Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 478",
    d: "M198.905 241.445L197.858 242.078L198.905 242.656V241.445Z",
    fill: "#6D6C6C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M152.16 223.366L301.954 126.074L350.878 153.273L292.147 184.736L266.19 196.796L211.324 225.418L152.16 223.366Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 435",
    d: "M190.066 210.259L235.148 184.212L255.999 196.157L210.917 222.204L190.066 210.259Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 436",
    d: "M210.942 222.182L255.972 196.19L255.972 199.155L210.942 226.11L210.942 222.182Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 438",
    d: "M215.939 175.879L229.517 168.902L229.517 199.85L215.939 207.746L215.939 175.879Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 440",
    d: "M205.716 169.827L215.961 175.664L215.961 207.702L205.715 201.865L205.716 169.827Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 437",
    d: "M190.162 210.307L210.947 222.191L210.947 226.083L190.162 214.199L190.162 210.307Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 439",
    d: "M191.859 181.049L228.865 159.758L239.095 165.627L202.09 186.918L191.859 181.049Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 441",
    d: "M149.532 114.593L281.671 38.093L290.224 43.0775L158.084 119.578L149.532 114.593Z",
    fill: "#6D6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 442",
    d: "M158.049 119.557L290.189 43.057L290.189 153.109L158.049 229.61L158.049 119.557Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 444",
    d: "M160.612 122.859L287.694 48.0071L287.694 143.427L160.612 218.28L160.612 122.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 443",
    d: "M149.555 114.602L158.071 119.572L158.071 229.587L149.679 224.652L149.555 114.602Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Site1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 541",
    d: "M160.64 135.882L287.78 60.8662V78.6804L160.64 153.696V135.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 183.427,
    y1: 123.538,
    x2: 183.427,
    y2: 139.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 209.427,
    y1: 108.538,
    x2: 209.427,
    y2: 124.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 236.427,
    y1: 91.5378,
    x2: 236.427,
    y2: 107.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 262.427,
    y1: 76.5378,
    x2: 262.427,
    y2: 92.9888,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 540",
    d: "M160.64 122.882L287.78 47.8662L287.78 62.7513L160.64 137.767V122.882Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab1",
    d: "M183.327 114.34L202.311 103.139L202.311 107.39L183.327 118.591L183.327 114.34Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab2",
    d: "M208.454 99.6528L227.438 88.4519L227.438 92.7034L208.454 103.904L208.454 99.6528Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab3",
    d: "M234.2 84.2004L253.184 72.9995L253.184 77.2511L234.2 88.452L234.2 84.2004Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 546",
    d: "M186.835 128.892L205.819 117.691L205.819 121.943L186.835 133.144L186.835 128.892Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 547",
    d: "M213.54 113.512L232.524 102.311L232.524 106.562L213.54 117.763L213.54 113.512Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 548",
    d: "M240.445 97.0592L259.429 85.8583L259.429 90.1098L240.445 101.311L240.445 97.0592Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 545",
    d: "M160.64 152.955L287.78 77.9392V139.878L160.64 214.893V152.955Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Netz-Logo Perspektivisch"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 85",
    cx: 170.929,
    cy: 141.569,
    rx: 2.05569,
    ry: 3.47029,
    transform: "rotate(14.3879 170.929 141.569)",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 91",
    cx: 173.191,
    cy: 134.726,
    rx: 1.57272,
    ry: 2.65498,
    transform: "rotate(14.3879 173.191 134.726)",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 92",
    cx: 175.237,
    cy: 138.233,
    rx: 1.13051,
    ry: 1.90847,
    transform: "rotate(14.3879 175.237 138.233)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 88",
    cx: 171.048,
    cy: 141.676,
    rx: 0.319055,
    ry: 0.532264,
    transform: "rotate(13.4279 171.048 141.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 89",
    cx: 175.3,
    cy: 138.233,
    rx: 0.178593,
    ry: 0.261142,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 90",
    cx: 173.307,
    cy: 134.954,
    rx: 0.237471,
    ry: 0.347234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 495_2",
    d: "M171.042 141.44L173.207 134.907L173.402 134.962L171.237 141.495L171.042 141.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 496",
    d: "M171.151 141.398L175.217 138.197L175.318 138.369L171.251 141.569L171.151 141.398Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Netz-Logo Perspektivisch_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 85_2",
    cx: 220.909,
    cy: 158.393,
    rx: 8.97321,
    ry: 15.1481,
    transform: "rotate(14.3879 220.909 158.393)",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 91_2",
    cx: 230.782,
    cy: 128.52,
    rx: 6.86504,
    ry: 11.5892,
    transform: "rotate(14.3879 230.782 128.52)",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 92_2",
    cx: 239.711,
    cy: 143.829,
    rx: 4.93477,
    ry: 8.33059,
    transform: "rotate(14.3879 239.711 143.829)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 88_2",
    cx: 221.426,
    cy: 158.856,
    rx: 1.3927,
    ry: 2.32337,
    transform: "rotate(13.4279 221.426 158.856)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 89_2",
    cx: 239.987,
    cy: 143.828,
    rx: 0.779572,
    ry: 1.1399,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 90_2",
    cx: 231.289,
    cy: 129.514,
    rx: 1.03658,
    ry: 1.5157,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 495_3",
    d: "M221.401 157.827L230.853 129.313L231.702 129.552L222.25 158.067L221.401 157.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 496_2",
    d: "M221.876 157.642L239.627 143.671L240.066 144.421L222.315 158.392L221.876 157.642Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Site2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 444_2",
    d: "M160.65 124.859L287.732 50.0071L287.732 145.427L160.65 220.28L160.65 124.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 541_2",
    d: "M160.64 135.882L287.78 60.8662V78.6804L160.64 153.696V135.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1_2",
    x1: 183.427,
    y1: 123.538,
    x2: 183.427,
    y2: 139.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2_2",
    x1: 209.427,
    y1: 108.538,
    x2: 209.427,
    y2: 124.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3_2",
    x1: 236.427,
    y1: 91.5378,
    x2: 236.427,
    y2: 107.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4_2",
    x1: 262.427,
    y1: 76.5378,
    x2: 262.427,
    y2: 92.9888,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 540_2",
    d: "M160.64 122.882L287.78 47.8662L287.78 62.7513L160.64 137.767V122.882Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab1_2",
    d: "M183.327 114.34L202.311 103.139L202.311 107.39L183.327 118.591L183.327 114.34Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab2_2",
    d: "M208.453 99.6528L227.437 88.4519L227.438 92.7034L208.454 103.904L208.453 99.6528Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab3_2",
    d: "M234.2 84.2004L253.184 72.9995L253.184 77.2511L234.2 88.452L234.2 84.2004Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 546_2",
    d: "M186.835 128.892L205.819 117.691L205.819 121.943L186.835 133.144L186.835 128.892Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 547_2",
    d: "M213.54 113.512L232.524 102.311L232.524 106.562L213.54 117.763L213.54 113.512Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 548_2",
    d: "M240.445 97.0592L259.429 85.8583L259.429 90.1098L240.445 101.311L240.445 97.0592Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 545_2",
    d: "M160.64 152.955L287.78 77.9392V108.041L160.64 183.057V152.955Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 550",
    d: "M223.32 155.998L265.154 131.417L265.154 132.019L223.32 156.689L223.32 155.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 551",
    d: "M223.32 158.998L265.154 134.417L265.154 135.019L223.32 159.689L223.32 158.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 552",
    d: "M223.32 161.998L265.154 137.417L265.154 138.019L223.32 162.689L223.32 161.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 553",
    d: "M223.32 164.998L265.154 140.417L265.154 141.019L223.32 165.689L223.32 164.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 554",
    d: "M223.32 167.998L265.154 143.417L265.154 144.019L223.32 168.689L223.32 167.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 555",
    d: "M223.32 170.998L265.154 146.417L265.154 147.019L223.32 171.689L223.32 170.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 556",
    d: "M223.32 173.998L265.154 149.417L265.154 150.019L223.32 174.689L223.32 173.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 557",
    d: "M223.32 176.998L265.154 152.417L265.154 153.019L223.32 177.689L223.32 176.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 558",
    d: "M223.32 179.998L265.154 155.417L265.154 156.019L223.32 180.689L223.32 179.998Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Netz-Logo Perspektivisch_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 85_3",
    cx: 170.929,
    cy: 141.569,
    rx: 2.05569,
    ry: 3.47029,
    transform: "rotate(14.3879 170.929 141.569)",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 91_3",
    cx: 173.191,
    cy: 134.726,
    rx: 1.57272,
    ry: 2.65498,
    transform: "rotate(14.3879 173.191 134.726)",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 92_3",
    cx: 175.237,
    cy: 138.233,
    rx: 1.13051,
    ry: 1.90847,
    transform: "rotate(14.3879 175.237 138.233)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 88_3",
    cx: 171.048,
    cy: 141.676,
    rx: 0.319055,
    ry: 0.532264,
    transform: "rotate(13.4279 171.048 141.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 89_3",
    cx: 175.3,
    cy: 138.233,
    rx: 0.178593,
    ry: 0.261142,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 90_3",
    cx: 173.307,
    cy: 134.954,
    rx: 0.237471,
    ry: 0.347234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 495_4",
    d: "M171.042 141.44L173.207 134.907L173.402 134.962L171.237 141.495L171.042 141.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 496_3",
    d: "M171.151 141.398L175.217 138.197L175.318 138.369L171.251 141.569L171.151 141.398Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549",
    d: "M185.471 176.255L216.549 157.987V185.386L185.471 203.605L185.471 176.255Z",
    fill: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Site3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 444_3",
    d: "M160.65 122.859L287.732 48.0071L287.732 143.427L160.65 218.28L160.65 122.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 541_3",
    d: "M160.64 135.882L287.78 60.8662V78.6804L160.64 153.696V135.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1_3",
    x1: 183.427,
    y1: 123.538,
    x2: 183.427,
    y2: 139.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2_3",
    x1: 209.427,
    y1: 108.538,
    x2: 209.427,
    y2: 124.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3_3",
    x1: 236.427,
    y1: 91.5378,
    x2: 236.427,
    y2: 107.989,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4_3",
    x1: 262.427,
    y1: 76.5378,
    x2: 262.427,
    y2: 92.9888,
    stroke: "#BBBBBB",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 540_3",
    d: "M160.64 122.882L287.78 47.8662L287.78 62.7513L160.64 137.767V122.882Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab1_3",
    d: "M183.327 114.34L202.311 103.139L202.311 107.39L183.327 118.591L183.327 114.34Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab2_3",
    d: "M208.453 99.6528L227.437 88.4519L227.438 92.7034L208.454 103.904L208.453 99.6528Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tab3_3",
    d: "M234.2 84.2004L253.184 72.9995L253.184 77.2511L234.2 88.452L234.2 84.2004Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 546_3",
    d: "M186.835 128.892L205.819 117.691L205.819 121.943L186.835 133.144L186.835 128.892Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 547_3",
    d: "M213.54 113.512L232.524 102.311L232.524 106.562L213.54 117.763L213.54 113.512Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 548_3",
    d: "M240.445 97.0593L259.429 85.8584L259.429 90.1099L240.445 101.311L240.445 97.0593Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 545_3",
    d: "M160.64 152.955L287.78 77.9392V108.041L160.64 183.057V152.955Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_2",
    d: "M185.471 176.255L222.961 154.202L222.961 183.636L185.471 205.64L185.471 176.255Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 550_2",
    d: "M231.719 149.065L269.209 127.011L269.209 156.418L231.719 178.422V149.065Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Netz-Logo Perspektivisch_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 85_4",
    cx: 170.929,
    cy: 141.569,
    rx: 2.05569,
    ry: 3.47029,
    transform: "rotate(14.3879 170.929 141.569)",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 91_4",
    cx: 173.191,
    cy: 134.726,
    rx: 1.57272,
    ry: 2.65498,
    transform: "rotate(14.3879 173.191 134.726)",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 92_4",
    cx: 175.237,
    cy: 138.233,
    rx: 1.13051,
    ry: 1.90847,
    transform: "rotate(14.3879 175.237 138.233)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 88_4",
    cx: 171.048,
    cy: 141.676,
    rx: 0.319055,
    ry: 0.532264,
    transform: "rotate(13.4279 171.048 141.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 89_4",
    cx: 175.3,
    cy: 138.233,
    rx: 0.178593,
    ry: 0.261142,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 90_4",
    cx: 173.307,
    cy: 134.954,
    rx: 0.237471,
    ry: 0.347234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 495_5",
    d: "M171.042 141.44L173.207 134.907L173.402 134.962L171.237 141.495L171.042 141.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 496_4",
    d: "M171.151 141.398L175.217 138.197L175.318 138.369L171.251 141.569L171.151 141.398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Maus"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-165-inside-1_1108_8371",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.472 90.8183L277.472 108.513L280.837 104.734L282.946 108.912L286.178 106.744L283.929 102.373L286.819 101.257L277.472 90.8183Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.472 90.8183L277.472 108.513L280.837 104.734L282.946 108.912L286.178 106.744L283.929 102.373L286.819 101.257L277.472 90.8183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.472 108.513L276.672 108.513L276.672 110.615L278.069 109.045L277.472 108.513ZM277.472 90.8183L278.068 90.2846L276.672 88.7256L276.672 90.8183L277.472 90.8183ZM280.837 104.734L281.551 104.373L281.022 103.324L280.24 104.202L280.837 104.734ZM282.946 108.912L282.232 109.273L282.64 110.081L283.392 109.577L282.946 108.912ZM286.178 106.744L286.624 107.409L287.216 107.012L286.89 106.378L286.178 106.744ZM283.929 102.373L283.641 101.627L282.811 101.948L283.218 102.739L283.929 102.373ZM286.819 101.257L287.107 102.004L288.188 101.586L287.415 100.724L286.819 101.257ZM278.272 108.513L278.272 90.8183L276.672 90.8183L276.672 108.513L278.272 108.513ZM280.24 104.202L276.874 107.981L278.069 109.045L281.435 105.266L280.24 104.202ZM283.66 108.552L281.551 104.373L280.123 105.094L282.232 109.273L283.66 108.552ZM285.733 106.08L282.5 108.248L283.392 109.577L286.624 107.409L285.733 106.08ZM283.218 102.739L285.467 107.11L286.89 106.378L284.641 102.007L283.218 102.739ZM286.531 100.511L283.641 101.627L284.218 103.12L287.107 102.004L286.531 100.511ZM276.876 91.3519L286.223 101.791L287.415 100.724L278.068 90.2846L276.876 91.3519Z",
    fill: "#565656",
    mask: "url(#path-165-inside-1_1108_8371)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M385.051 206.395C395.124 210.551 395.124 217.408 385.051 221.743C373.705 225.988 360.281 225.988 348.937 221.743C338.866 217.588 338.866 210.729 348.937 206.395C360.281 202.15 373.705 202.15 385.051 206.395Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M366.432 213.765L361.061 181.491C361.19 182.808 360.534 183.812 359.091 184.719C356.358 186.437 351.829 186.674 348.975 185.166C347.492 184.384 346.755 183.352 346.77 182.27L346.767 182.27L343.53 215.946C343.361 217.844 344.563 219.718 347.117 221.068C351.779 223.532 359.179 223.219 363.642 220.412C366.624 218.537 367.538 215.972 366.432 213.765Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M341.647 120.404C356.58 120.404 368.687 132.889 368.687 148.289C368.687 163.688 356.58 176.173 341.647 176.173C326.713 176.173 314.607 163.688 314.607 148.289C314.607 132.889 326.713 120.404 341.647 120.404Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M356.909 141.836C348.009 146.713 333.59 146.713 324.69 141.836C320.634 139.669 318.493 136.743 318.043 133.924C317.591 137.502 319.733 141.076 324.69 143.786C333.59 148.663 348.009 148.663 356.909 143.786C361.755 141.076 364.008 137.5 363.557 133.924C363.105 136.85 360.967 139.664 356.909 141.836Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M359.296 161.414C349.078 166.901 332.522 166.901 322.304 161.414C317.647 158.976 315.189 155.685 314.672 152.513C314.154 156.538 316.612 160.56 322.304 163.608C332.522 169.095 349.078 169.095 359.296 163.608C364.86 160.56 367.446 156.536 366.929 152.513C366.411 155.805 363.955 158.971 359.296 161.414Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M365.303 133.924C380.237 133.924 392.343 146.409 392.343 161.809C392.343 177.208 380.237 189.693 365.303 189.693C350.369 189.693 338.264 177.208 338.264 161.809C338.264 146.409 350.369 133.924 365.303 133.924Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M382.01 155.355C372.78 160.232 357.827 160.232 348.597 155.355C344.391 153.188 342.171 150.262 341.704 147.443C341.236 151.02 343.457 154.595 348.597 157.305C357.827 162.182 372.78 162.182 382.01 157.305C387.035 154.595 389.371 151.019 388.904 147.443C388.436 150.369 386.218 153.183 382.01 155.355Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M384.648 174.934C374.43 180.421 357.875 180.421 347.656 174.934C342.999 172.496 340.542 169.204 340.024 166.033C339.506 170.058 341.965 174.079 347.656 177.128C357.875 182.614 374.43 182.614 384.648 177.128C390.212 174.079 392.799 170.056 392.281 166.033C391.763 169.325 389.308 172.491 384.648 174.934Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M341.644 157.584C351.91 157.584 360.233 166.286 360.233 177.019C360.233 187.752 351.91 196.454 341.644 196.454C331.376 196.454 323.054 187.752 323.054 177.019C323.054 166.286 331.376 157.584 341.644 157.584Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M352.135 173.658C345.872 177.315 335.725 177.315 329.462 173.658C326.608 172.032 325.102 169.838 324.785 167.724C324.467 170.407 325.974 173.088 329.462 175.12C335.725 178.778 345.872 178.778 352.135 175.12C355.545 173.088 357.13 170.405 356.813 167.724C356.495 169.918 354.99 172.029 352.135 173.658Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M354.771 187.177C347.519 190.834 335.77 190.834 328.518 187.177C325.213 185.551 323.469 183.357 323.102 181.243C322.734 183.926 324.479 186.607 328.518 188.639C335.77 192.297 347.519 192.297 354.771 188.639C358.719 186.607 360.555 183.924 360.188 181.243C359.82 183.437 358.077 185.548 354.771 187.177Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M160.64 220.285L287.701 145.437L380.784 170.625L455.375 209.511L237.09 336.961L160.64 272.094L160.64 220.285Z",
    fill: "url(#paint0_linear_1108_8371)",
    fillOpacity: 0.47
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1108_8371",
    x1: 225.299,
    y1: 160.989,
    x2: 249.528,
    y2: 201.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineServices);
export default __webpack_public_path__ + "static/media/OnlineServices.25616c1382e1e4eb26311fe17c296f77.svg";
export { ForwardRef as ReactComponent };